import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4eaaecd7"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container long-container wow animate__animated animate__fadeInUp",
  "data-wow-duration": "2s",
  "data-wow-delay": "0.1s"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "textArea"
  }, [/*#__PURE__*/_createElementVNode("h3", null, "行业新闻")], -1);
});

var _hoisted_3 = {
  class: "row"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "img-container"
};
var _hoisted_6 = ["src", "alt"];
var _hoisted_7 = {
  class: "textArea"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    href: "/news",
    class: "more"
  }, "了解更多", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.homeNewsList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
      key: item.id
    }, [_createElementVNode("div", {
      class: "thumbnail long-thumbnail",
      onClick: function onClick($event) {
        return $setup.goNewsDetail(item);
      }
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      src: item.imgUrl,
      alt: item.title
    }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("h3", null, _toDisplayString(item.title), 1), _createElementVNode("p", null, _toDisplayString(item.releaseDate), 1)])], 8, _hoisted_4)]);
  }), 128))]), _hoisted_8]);
}